<template>
	<nav id="nav">
		<!-- <router-link to="/ofertas-especiais" class="item__nav">Ofertas<br class="brDesk"> Especiais <Icons name="arrowRight"/> </router-link> -->
		<!-- <a href="/#ofertas-especiais" class="item__nav">Ofertas<br class="brDesk"> Especiais <Icons name="arrowRight"/> </a> -->
		
		<!-- OLD -->
		<!-- <router-link :to="{ name: 'lancamentos' }" class="item__nav" :aria-label="$t('nav.lancamentos')"><span
				v-html="$t('nav.lancamentos')"></span>
			<Icons name="arrowRight" />
		</router-link>
		<router-link :to="{ name: 'experiencia-exclusiva' }" class="item__nav" :aria-label="$t('nav.experiencia')"><span
				v-html="$t('nav.experiencia')"></span>
			<Icons name="arrowRight" />
		</router-link>
		<a @click.prevent="openWhatsappModal($event)" href="#" class="item__nav" :aria-label="$t('nav.atendimento')"><span
				v-html="$t('nav.atendimento')"></span>
			<Icons name="arrowRight" />
		</a>
		
		<a v-if="login.logged"
			href="https://www.lg.com/br/partners/?code=c623a735957bfcf9ffac8f057e8a476e71f9c46cd24d6dfdfa93c6cc8d7eaa0a"
			target="_blank" class="item__nav" :aria-label="$t('nav.atendimento')"><span v-html="$t('nav.shop')"></span>
			<Icons name="arrowRight" />
		</a> -->
		<!-- OLD -->


		<!--NOVOS  -->
		<!-- <router-link to="/" class="item__nav" aria-label="Comunidades"><span>Comunidades</span><Icons name="arrowRight" /></router-link> -->
		<router-link v-if="launchesEnabled && hasLaunches" :to="{ name: 'lancamentos' }" class="item__nav" :aria-label="$t('nav.lancamentos')" @click="handleCardClick('lancamentos')"><span v-html="$t('nav.lancamentos')"></span><Icons name="arrowRight" /></router-link>
		<router-link v-if="hasUpdates" :to="{ name: 'updates' }" class="item__nav" :aria-label="$t('nav.novidades')" @click="handleCardClick('Novidades')"><span v-html="$t('nav.novidades')"></span><Icons name="arrowRight" /></router-link>
		<router-link v-if="hasNews" :to="{ name: 'news' }" class="item__nav" :aria-label="$t('nav.news')" @click="handleCardClick('noticias')"><span v-html="$t('nav.news')" ></span><Icons name="arrowRight" /></router-link>
		<router-link v-if="hasTips" :to="{ name: 'tipsTutorials' }" class="item__nav" :aria-label="$t('nav.tutoriais')" @click="handleCardClick('Dicas e Tutoriais')"><span v-html="$t('nav.tutoriais')"></span><Icons name="arrowRight" /></router-link>
		<router-link v-if="discourseEnabled" :to="{ name: 'forum' }" class="item__nav" :aria-label="$t('nav.community')" @click="handleCardClick('forum')"><span v-html="$t('nav.community')"></span><Icons name="arrowRight" /></router-link>
		<router-link :to="{ name: 'experiencia-exclusiva' }" class="item__nav" :aria-label="$t('nav.experiencia')" @click="handleCardClick('experiencia exclusiva')"><span v-html="$t('nav.experiencia')"></span><Icons name="arrowRight" /></router-link>

	
		<!-- <router-link to="https://www.lg.com/br/partners/?code=c623a735957bfcf9ffac8f057e8a476e71f9c46cd24d6dfdfa93c6cc8d7eaa0a" class="item__nav" aria-label="Dicas e Tutoriais"><span>Shop</span><Icons name="arrowRight" /></router-link> -->
		<a v-if="shopEnabled"
			href="https://www.lg.com/br/&utm_source=referral&utm_medium=familyclub/"
			target="_blank" class="item__nav" :aria-label="$t('nav.atendimento')" @click="handleCardClick('shop')"><span v-html="$t('nav.shop')"></span>
			<Icons name="arrowRight" />
		</a> 
		<!--NOVOS  -->





	</nav>
</template>

<script>
import Icons from '@/components/Icons.vue';
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
	name: 'nav',
	components: { Icons },
	emits: ['navigate'],
	props: {
		onClickCard: {
			type: Function,
			default: null
		}
	},
	data() {
		return {
			hasLaunches: false,
			hasUpdates: false,
			hasNews: false,
			hasTips: false,
		}
	},
	mounted() {
		this.checkNavContents()
	},
	computed: {
		...mapState('auth', ['user']),
		...mapGetters(['exclusiveServiceModalOpened']),
		login() {
			return {
				name: this.$store.state.auth.user?.name,
				logged: !!this.$store.state.auth.user
			}
		},
		discourseEnabled() {
			return __DISCOURSE_ENABLED__
		},
		shopEnabled() {
			return __SHOP_ENABLED__
		},
		launchesEnabled() {
			return __LAUNCHES_ENABLED__
		}
	},
	methods: {
		...mapActions(['exclusiveServiceModal']),
		openWhatsappModal(event) {
			event.preventDefault();
			this.exclusiveServiceModal()
		},
		handleCardClick(element) {			
			if (typeof this.onClickCard === 'function')
				this.onClickCard("nav_tab_click", element)
			this.$emit('navigate')
		},
		async checkNavContents() {
			const response = await this.$store.dispatch('contents/getAllContents', { limit: 1, page: 1 });

			const rows = response?.data?.data

			const checks = [
				{ type: 1, key:  'hasLaunches' },
				{ type: 9, key:  'hasUpdates'  },
				{ type: 8, key:  'hasNews'     },
				{ type: 10, key: 'hasTips' 	   }
			]

			checks.forEach(({ type, key }) => {
				this[key] = rows.some(row => row.contentTypeId === type)
			})
		}
	}
}
</script>

<style lang="sass" scoped>
@use '../../assets/sass/utilities/_colors' as *
@use '../../assets/sass/utilities/_responsive' as *

#nav
	display: flex
	flex-direction: column
	align-items: flex-start
	width: 100%
	+respond-to($breakpoint-xs-min)
		gap: 2rem
		margin-top: 0
		flex-direction: row
		align-items: center
		justify-content: center

   

	.item__nav
		--c: var(--white)

		display: flex
		justify-content: space-between
		
		text-align: center
		align-items: center
		text-decoration: none
		font-size: 1rem
		color: var(--lg-dark-gray-300)
		font-weight: 400
		width: 100%
		white-space: nowrap
		text-align: left
		padding-block: 0.875rem
		border-bottom: 0.0625rem solid var(--lg-light-gray-300)
		+respond-to($breakpoint-xs-min)
			position: relative
			width: auto
			font-size: clamp(0.75rem, 0.9vw, 0.875rem)
			color: var(--white)
			padding-block: 0
			border-bottom: none
			text-align: center

			&::after
				content: ''
				position: absolute
				right: 0
				bottom: -0.625rem
				left: 0
				height: 0.125rem
				border-radius: 99999px
				background-color: var(--white)
				transform: scaleX(0)
				transform-origin: center
				transition: transform 0.2s ease

			&:hover::after,
			&:focus-visible::after,
			&.active::after
				transform: scaleX(1)

			&:focus-visible
				outline: 0.125rem solid var(--white)
				outline-offset: 0.5rem

		i
			display: block
			width: 1.25rem
			color: var(--lg-mid-gray-200)

			:deep(path)
				stroke-width: 1.5

			+respond-to($breakpoint-xs-min)
				display: none
	   

		// &:hover, &.active
		// 	// --c: var(--lg-red-active)

		&:last-child
			border-bottom: none
			padding-bottom: 0

@media (prefers-reduced-motion: reduce)
	#nav .item__nav::after
		transition: none
			

</style>
